module.exports = __webpack_public_path__ + "media/images/favicon-fff16ff6988c16fc2884d12589054636.ico";